import { useEffect, useState } from 'react';

export function useTypingEffect(text, msPerChar = 5, enabled = true) {
    const [typedText, setTypedText] = useState('');
    const [isFinished, setIsFinished] = useState(false);

    useEffect(() => {
        if (!enabled || !text) {
            setTypedText('');
            setIsFinished(false);
            return;
        }

        setTypedText('');
        setIsFinished(false);
        let index = 0;

        const interval = setInterval(() => {
            index += 1;
            setTypedText(text.slice(0, index));
            if (index >= text.length) {
                setIsFinished(true);
                clearInterval(interval);
            }
        }, msPerChar);

        return () => clearInterval(interval);
    }, [text, msPerChar, enabled]);

    return [typedText, isFinished];
}
